const SHORT_ID_FORMAT = /^[a-zA-z0-9]+$/

export const isShortId = (value?: string): value is string => {
  return !!value && SHORT_ID_FORMAT.test(value)
}
